import React, {
    useState
} from "react";
import {
    Row,
    Col,
    Button,
    Modal
} from "react-bootstrap";
import Select from "react-select";
import './ApprovalMessageModal.css'

export const ApprovalMessageModal = (props) => {
    const [message, setMessage] = useState()
    const [selectedRejectionOption, setSelectedRejectionOption] = useState()
    const rejectionOptions =
        props.rejectOptions && props.rejectOptions.length > 0
            ? props.rejectOptions.map((opt) => ({
                label: opt,
                value: opt
            }))
            : [
                { label: "Independence issues", value: "Independence issues" },
                { label: "Integrity issues or dishonest", value: "Integrity issues or dishonest" },
                { label: "High risk or unusual risks", value: "High risk or unusual risks" },
                { label: "Mismatch of expertise", value: "Mismatch of expertise" },
                { label: "Lack of client cooperation or transparency", value: "Lack of client cooperation or transparency" },
                { label: "Fees", value: "Fees" },
                { label: "Other", value: "Other" }
            ];
    const continueApi = () => {
        const merged_message = selectedRejectionOption.value + ": "+ message
        props.approvalcontinuation(merged_message)
        props.onHide()
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
            backdropClassName="approval-message-modal"
            centered
            scrollable="false"
            keyboard={false}
        >
            <Modal.Header className="row no-gutter" style={{ paddingLeft: "0px" }}>
                <Col md={8}>
                    <div className="form-select-wrapper" style={{ float: 'left', width: 300, marginLeft: 5 }}>
                        <Select
                            value={selectedRejectionOption}
                            onChange={(e) => setSelectedRejectionOption(e)}
                            options={rejectionOptions}
                            className="form-select custom-select"
                            aria-label="Default"
                            closeMenuOnSelect={true}
                            autosize={true}
                            placeholder="Select a reason for refusal"
                            menuPosition="fixed"
                            classNamePrefix="react-select"
                        />
                    </div>
                </Col>

            </Modal.Header>
            <Modal.Body style={{ paddingTop: 0, paddingBottom: 0 }} >
                <Row className="no-gutter flex-row-start-center">
                    <textarea rows={5} className="form-control move-left custom-input" id="message" aria-describedby="emailHelp"
                        placeholder={"Please enter a message"}
                        value={message}
                        onChange={event => {
                            setMessage(event.target.value)
                        }}
                    />
                </Row>
            </Modal.Body>
            <Modal.Footer style={{ padding: "0px" }}>
                <Row>
                    <div className="flex-row-center-start" style={{ float: 'right', width: '100%' }}>
                        <Button className="custom-button" style={{
                            width: "fit-content",
                            display: "inline-block",
                            padding: "10px 20px",
                            margin: "10px 0px 15px 15px"
                        }} onClick={() => props.onHide()} >
                            Cancel
                        </Button>
                        <Button className="custom-button" style={{
                            width: "fit-content",
                            display: "inline-block",
                            padding: "10px 20px",
                            margin: "10px 0px 15px 25px"
                        }} onClick={() => continueApi()} >
                            Submit
                        </Button>
                    </div>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}